import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Box, Button, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface TravelerPageHeaderProps {
  orderId: string;
  date: string;
  onExportPdf: () => void;
  canExportPdf: boolean;
}

const TravelerPageHeader = ({
  orderId,
  date,
  onExportPdf,
  canExportPdf,
}: TravelerPageHeaderProps) => {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        mb: 2.5,
      }}
    >
      <Typography variant="h6" sx={{ fontWeight: 500, fontSize: '18px' }}>
        Work Order Traveler -{' '}
        <Box component="span" sx={{ color: 'primary.main' }}>
          {date}
        </Box>
      </Typography>
      <Box sx={{ display: 'flex', gap: 1.5 }}>
        {canExportPdf && (
          <Button
            variant="outlined"
            startIcon={<PictureAsPdfIcon />}
            onClick={onExportPdf}
            size="small"
          >
            PDF
          </Button>
        )}
        <Button
          variant="outlined"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate(`/order-details/${orderId}`)}
          size="small"
        >
          Back to Order
        </Button>
        <Button
          variant="contained"
          startIcon={<ArrowBackIcon />}
          onClick={() => navigate('/order-management')}
          size="small"
        >
          Back to Order List
        </Button>
      </Box>
    </Box>
  );
};

export default TravelerPageHeader;
